/**
 * Queries do COFRE DE SENHAS. IMPORTANTE: o segredo NUNCA passa por aqui —
 * listagens/árvore não carregam senha e o reveal é mutation (vault-mutations),
 * para nunca entrar no cache do react-query.
 */
import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { Vault, VaultLog, VaultTree } from '@erp/shared';

export { errorMessage } from '@/features/tickets/ticket-format';

/** GET /vault — cofres a que tenho acesso (com meu nível efetivo). */
export function myVaultsOptions() {
  return queryOptions({
    queryKey: ['erp', 'vault', 'list'] as const,
    queryFn: async ({ signal }) => {
      const res = await api<Vault[]>('/vault', { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

/** GET /vault/:id/tree — cofre + permissões + pastas (flat) + entradas SEM segredo. */
export function vaultTreeOptions(vaultId: number) {
  return queryOptions({
    queryKey: ['erp', 'vault', 'tree', vaultId] as const,
    queryFn: async ({ signal }) => {
      const res = await api<VaultTree>(`/vault/${vaultId}/tree`, { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

/** GET /vault/:id/logs — auditoria (criada/atualizada/revelada/excluída). */
export function vaultLogsOptions(vaultId: number) {
  return queryOptions({
    queryKey: ['erp', 'vault', 'logs', vaultId] as const,
    queryFn: async ({ signal }) => {
      const res = await api<VaultLog[]>(`/vault/${vaultId}/logs`, { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
